const CONSTANTS = {
	ALBUM: {
		THRESHOLD: 35,
		SALE_EXTRA_CHARGE: 42, // In cents
		EXTRA_CHARGE: 77,
		MAX_INPUT: 5000,
	},
	FILM: {
		THRESHOLD: 100,
		SALE_EXTRA_CHARGE: 15, // In cents
		EXTRA_CHARGE: 28,
		MAX_INPUT: 99,
	},
	PHOTO: {
		THRESHOLD: 50,
		SALE_EXTRA_CHARGE: 30, // In cents
		EXTRA_CHARGE: 55,
		MAX_INPUT: 5000,
	},
	VIDEO: {
		THRESHOLD: 15,
	},
	DIGITAL: {
		THRESHOLD: 15,
	},
	USB: {
		MAX_INPUT: 99,
	},
	DVD: {
		MAX_INPUT: 99,
	},
	PRODUCT_TEMPLATE_MAP: {
		album_scan: "album",
		tapes: "video",
		films: "film",
		images: "photo",
		digital_media: "digital-media",
	},
	TEMPLATE_PRODUCT_MAP: {
		album: "album_scan",
		video: "tapes",
		film: "films",
		photo: "images",
		"digital-media": "digital_media",
		usb: "usb",
	},
};
